module.exports = __webpack_public_path__ + "img/s1_t1_19.9f35276e.jpeg";